export default __webpack_public_path__ + "static/media/TECHNOLOGIA.efe930ae.png";